import { Box, Caption } from "@bcc-ui/ui-components";
import * as React from "react";
import { useTranslation } from "react-i18next";

import { ShieldCheck } from "components/icons/ShieldCheck";
import style from "components/reports/passports/passports-view.scss";

import testIds from "testIds.json";

interface Props {
    className?: string;
}

export const CertifiedBadge = (props: Props) => {
    const { t } = useTranslation();
    return (
        <Box verticalAlignment="Center" gap="Sm" className={props.className}>
            <div className={style.certifiedBadge} data-testid={testIds.workArea.passports.certifiedBadge}>
                <ShieldCheck />
                <span>+ {t("DevicePassport.certified")}</span>
            </div>
            <Caption className={style.dataSourceNote}>{t("DevicePassport.dataSourceNote")}</Caption>
        </Box>
    );
};
